module.exports = __webpack_public_path__ + "img/szbwg.9f800cee.png";